import { api } from "./client";

export type ExportRunStatus = "processing" | "ok" | "failed";
export type ExportSource = "manual_upload" | "playwright_auto";

export type ExportRun = {
  id: number;
  uploaded_by_id: number | null;
  uploaded_by_email: string | null;
  uploaded_at: string;
  source: ExportSource;
  date_range_start: string | null;
  date_range_end: string | null;
  file_size_bytes: number | null;
  conversations_imported: number;
  turns_imported: number;
  users_created: number;
  status: ExportRunStatus;
  error_message: string | null;
  completed_at: string | null;
};

export type ExportRunCreated = {
  export_run_id: number;
  status: ExportRunStatus;
};

export const importsApi = {
  uploadExport: (file: File) => {
    const form = new FormData();
    form.append("file", file);
    return api.postForm<ExportRunCreated>("/admin/upload-export", form);
  },
  listExportRuns: () => api.get<ExportRun[]>("/admin/export-runs"),
  getExportRun: (id: number) => api.get<ExportRun>(`/admin/export-runs/${id}`),
};
